import { getCategoryMenu } from "@/services/categoryCardService";
import { useQuery } from "@tanstack/react-query";

function useCategoryMenu() {
  return useQuery({
    queryKey: ["menus"],
    queryFn: getCategoryMenu,
    staleTime: 1000 * 60 * 10,
    retry: 2,
    retryDelay: 1000,
  });
}

export default useCategoryMenu;
